import AuthenticatedLayout from "./authenticatedLayout";

export default AuthenticatedLayout;